import React from 'react';

import { Link } from 'apps/product/types';

interface Props {
  links: Link[];
}

export const Links: React.FC<Props> = ({ links }) => {
  const items = links.map(({ displayText, url }, index) => {
    const linkClassName = index === 0 ? 'button' : 'button button--outline';
    return (
      <a key={index} href={url} className={linkClassName}>
        {displayText}
      </a>
    );
  });

  return <div className="scalable-content-section__links">{items}</div>;
};
